"use strict";
exports.__esModule = true;
exports.detect = exports.uuid = exports.trim = void 0;
function trim(target) {
    return target.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
exports.trim = trim;
function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (s) {
        var t = (Math.random() * 16) | 0;
        return (s === 'x' ? t : (3 & t) | 8).toString(16);
    });
}
exports.uuid = uuid;
var OS = [
    { regexp: /Windows/, name: 'Windows' },
    { regexp: /Android/, name: 'Android' },
    { regexp: /(Linux|X11)/, name: 'Linux' },
    { regexp: /iPhone/, name: 'iOS' },
    { regexp: /iPad/, name: 'iPad' },
    { regexp: /Mac OS X/, name: 'Mac OS X' },
    { regexp: /UNIX/, name: 'UNIX' }
];
var Browser = [
    { regexp: /msie/i, name: 'IE' },
    { regexp: /Chrome/, name: 'Chrome' },
    { regexp: [/Safari/, /^((?!Chrome).)*$/], name: 'Safari' },
    { regexp: /Firefox/, name: 'Firefox' },
    { regexp: /Opera/, name: 'Opera' },
    { regexp: /Edge/, name: 'Edge' },
    { regexp: /qqbrowser/, name: 'QQ' },
];
function detect() {
    var _a, _b, _c, _d, _e, _f, _g;
    var userAgent = window.navigator.userAgent;
    var fallback = '-';
    var os = fallback;
    var osVersion = fallback;
    var browser = fallback;
    var browserVersion = fallback;
    for (var i = 0; i < OS.length; i += 1) {
        var current = OS[i];
        if (current.regexp.test(userAgent)) {
            os = current.name;
            break;
        }
    }
    switch (os) {
        case 'Windows':
            _a = /Windows (.*)/.exec(userAgent) || [, fallback], osVersion = _a[1];
            break;
        case 'Mac OS X':
            _b = /Mac OS X (10[._\d]+)/.exec(userAgent) || [, fallback], osVersion = _b[1];
            break;
        case 'Android':
            _c = /Android ([._\d]+)/.exec(userAgent) || [, fallback], osVersion = _c[1];
            break;
        case 'iOS':
        case 'iPad':
            var res = /OS (\d+)_(\d+)_?(\d+)?/.exec(userAgent) || [];
            osVersion = (res[1] || fallback) + "." + (res[2] || fallback) + "." + (res[3] || fallback);
            break;
    }
    for (var i = 0; i < Browser.length; i += 1) {
        var _h = Browser[i], regexp = _h.regexp, name_1 = _h.name;
        var matched = false;
        if (Array.isArray(regexp)) {
            matched = regexp.every(function (reg) { return reg.test(userAgent); });
        }
        else {
            matched = regexp.test(userAgent);
        }
        if (matched) {
            browser = name_1;
            break;
        }
    }
    switch (browser) {
        case 'IE':
            _d = new RegExp("msie/([\\w.]+)").exec(userAgent) || [, fallback], browserVersion = _d[1];
            break;
        case 'Chrome':
        case 'Firefox':
        case 'Opera':
        case 'Edge':
            _e = new RegExp(browser + "/([\\d.]+)").exec(userAgent) || [, fallback], browserVersion = _e[1];
            break;
        case 'Safari':
            _f = new RegExp("Version/([\\d.]+)").exec(userAgent) || [, fallback], browserVersion = _f[1];
            break;
        case 'QQ':
            _g = new RegExp("qqbrowser/([\\d.]+)").exec(userAgent) || [, fallback], browserVersion = _g[1];
            break;
    }
    return { webSystem: os + " " + osVersion, webBrowser: browser, webbsVersion: browserVersion };
}
exports.detect = detect;
